import { Component, OnInit } from '@angular/core';

import { Hotel } from '../classes/hotel';
import { HotelService } from './hotel.service'
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-hotel',
  templateUrl: './hotel.component.html',
  styleUrls: ['./hotel.component.css']
})
export class HotelComponent implements OnInit {
    public hotel:Hotel;
    public errormessage:String;
    
  constructor(private hotelService:HotelService, private loginService: LoginService) { }

  ngOnInit() {
      this.hotelService.getHotel()
        .subscribe((data) => {
          if (data != null && data.error==null) {
              this.hotel=data.hotel
              console.log('returned hotel json: ' + JSON.stringify(this.hotel, null, 2));
          } else {  // Book not found, get error message
            this.errormessage = "Erreur au chargement des données";
            console.log('Erreur au chargement des données')
            // this.router.navigate(['/errorpage']);
          }
        });
    }
  
  private onSubmit() {  // Save hotel
      console.log("On hotel submit");
      this.hotelService.updateHotel(this.hotel)
      .subscribe((data) => {
        if (data != null && data.error==null) {
            console.log('Updated hotel');
        } else {  // Book not found, get error message
          this.errormessage = "Erreur à la mise à jour de l'hotel";
          console.log("Erreur à la mise à jour de l'hotel")
          // this.router.navigate(['/errorpage']);
        }
      });      
  }
}
